import _Object$assign from "@babel/runtime-corejs2/core-js/object/assign";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs2/core-js/object/get-own-property-symbols";

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof _Object$getOwnPropertySymbols === "function") for (var i = 0, p = _Object$getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

import * as React from 'react';
import * as ReactDOM from 'react-dom';
import { disableBodyScroll, enableBodyScroll } from '../_utils/Dom';
import Modal from './Modal';

var ConfirmModal = function ConfirmModal(props) {
  var onClose = props.onClose,
      onCancel = props.onCancel,
      onOpen = props.onOpen,
      onConfirm = props.onConfirm,
      closeWrap = props.closeWrap,
      status = props.status,
      restProps = __rest(props, ["onClose", "onCancel", "onOpen", "onConfirm", "closeWrap", "status"]);

  var handleClose = function handleClose(e, type) {
    if (onClose && onClose(e, type) === false) {
      return;
    }

    if (onCancel && onCancel(e, type) === false) {
      return;
    }

    closeWrap();
  };

  var handleOpen = function handleOpen(e) {
    if (onOpen && onOpen(e) === false) {
      return;
    }

    if (onConfirm && onConfirm(e) === false) {
      return;
    }

    closeWrap();
  };

  var relStatue = status || 'normal';
  var isShowCloseButton = !(['success', 'info', 'danger'].indexOf(relStatue) > -1);

  if (restProps.showCancelButton !== undefined) {
    isShowCloseButton = true;
  }

  var currentProps = _Object$assign({
    closable: false,
    // @ts-ignore
    showCloseButton: isShowCloseButton,
    onCancel: handleClose,
    onConfirm: handleOpen,
    status: status
  }, restProps);

  return /*#__PURE__*/React.createElement(Modal, _Object$assign({}, currentProps));
};

export default function confirm(config) {
  var currentConfig = _Object$assign(_Object$assign({}, config), {
    closeWrap: close,
    visible: true
  });

  var div = document.createElement('div');
  document.body.appendChild(div);

  function close() {
    currentConfig = _Object$assign(_Object$assign({}, currentConfig), {
      visible: false
    });
    render(currentConfig);
    destroy();
  }

  function destroy() {
    var unmountResult = ReactDOM.unmountComponentAtNode(div);

    if (unmountResult && div.parentNode) {
      div.parentNode.removeChild(div);
    }

    enableBodyScroll();
  }

  function render(props) {
    disableBodyScroll(); // 使用方法时，没有 React 组件的层级结构，所以挂载在一个独立的容器下。

    ReactDOM.render( /*#__PURE__*/React.createElement(ConfirmModal, _Object$assign({}, props)), div);
  }

  render(currentConfig);
  return {
    close: close
  };
}